import TextFade from "../../components/CustomTexts/TextFade";
//import CallToActionSection from "../../components/Others/CallToActionSection";
import heroImage from "../../assets/Shabu-Training-2021/ok.jpg";
import sandDredgingImage from "../../assets/Shabu-Training-2021/training.jpg";
import missionImage from "../../assets/Iwomen.png";
import TextEffect from "../../components/CustomTexts/TextEffect";
import bgIMG from "../../assets/tan2.jpg";
import trainingImg from "../../assets/Shabu-Training-2021/work.jpg";
import chysonImg from "../../assets/Shabu-Training-2021/traininh.jpg";
import farmImg from "../../assets/Shabu-Training-2021/big.jpg";
import consultancyImg from "../../assets/Shabu-Training-2021/mentor.jpg";
import consultancy2Img from "../../assets/Shabu-Training-2021/ok.jpg";
import consultancy3Img from "../../assets/Shabu-Training-2021/consultancy3Img.jpg";
import consultancy4Img from "../../assets/Shabu-Training-2021/consultancy4Img.jpg";
import consultancy5Img from "../../assets/Shabu-Training-2021/consultancy5Img.jpg";
import consultancy6Img from "../../assets/Shabu-Training-2021/consultancy6Img.jpg";
import consultancy7Img from "../../assets/Shabu-Training-2021/consultancy7Img.jpg";
import consultancy8Img from "../../assets/Shabu-Training-2021/consultancy8Img.jpg";
import consultancy9Img from "../../assets/Shabu-Training-2021/consultancy9Img.jpg";
import consultancy10Img from "../../assets/Shabu-Training-2021/consultancy10Img.jpg";
import consultancy11Img from "../../assets/Shabu-Training-2021/consultancy11Img.jpg";
import consultancy12Img from "../../assets/Shabu-Training-2021/consultancy12Img.jpg";
import consultancy13Img from "../../assets/Shabu-Training-2021/consultancy13Img.jpg";
import consultancy14Img from "../../assets/Shabu-Training-2021/consultancy14Img.jpg";
import consultancy15Img from "../../assets/Shabu-Training-2021/consultancy15Img.jpg";
import consultancy16Img from "../../assets/Shabu-Training-2021/consultancy16Img.jpg";
import consultancy17Img from "../../assets/Shabu-Training-2021/consultancy17Img.jpg";
import consultancy18Img from "../../assets/Shabu-Training-2021/consultancy18Img.jpg";
import consultancy19Img from "../../assets/Shabu-Training-2021/consultancy19Img.jpg";
import consultancy20Img from "../../assets/Shabu-Training-2021/consultancy21Img.jpg";
import consultancy21Img from "../../assets/Shabu-Training-2021/consultancy22Img.jpg";
import consultancy22Img from "../../assets/Shabu-Training-2021/consultancy23Img.jpg";
import consultancy23Img from "../../assets/Shabu-Training-2021/consultancy24Img.jpg";
import consultancy24Img from "../../assets/Shabu-Training-2021/consultancy25Img.jpg";
import consultancy25Img from "../../assets/Shabu-Training-2021/shabu-main.jpg";
//import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useState } from "react";

const ImageModal = ({ image, caption, onClose }: { image: string, caption: string, onClose: () => void }) => (
  <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full overflow-hidden relative">
      <img src={image} alt={caption} className="w-full max-h-[80vh] object-contain" />
      <p className="text-center text-lg font-semibold text-dark py-4">{caption}</p>
      <button
        onClick={onClose}
        className="absolute top-2 right-2 text-white bg-black rounded-full p-2 hover:bg-gray-700"
      >
        ✕
      </button>
    </div>
  </div>
);

const ShabuTraining = () => {
  const [modal, setModal] = useState<{ img: string; caption: string } | null>(null);
  const [activeTab, setActiveTab] = useState("participation");

  const trainingGallery = [
    { img: consultancy7Img, caption: "Hands-On Workshop" },
    { img: trainingImg, caption: "Personalized Mentorship" },
    { img: farmImg, caption: "Empowering Farmers" },
    { img: sandDredgingImage, caption: "Field Experience" },
    { img: consultancyImg, caption: "Consultancy Session" },
    { img: consultancy2Img, caption: "Knowledge Sharing" },
    { img: consultancy3Img, caption: "Community Engagement" },
    { img: consultancy4Img, caption: "Sustainable Practices" },
    { img: consultancy5Img, caption: "Innovative Solutions" },
    { img: consultancy6Img, caption: "Agricultural Training" },
    { img: consultancy8Img, caption: "Empowering Youth" },
    { img: consultancy9Img, caption: "Hands-On Learning" },
    { img: consultancy10Img, caption: "Field Demonstration" },
    { img: consultancy11Img, caption: "Practical Skills" },
    { img: consultancy12Img, caption: "Community Impact" },
    { img: consultancy13Img, caption: "Agribusiness Development" },
    { img: consultancy14Img, caption: "Sustainable Agriculture" },
    { img: consultancy15Img, caption: "Training Session" },
    { img: consultancy16Img, caption: "Empowering Farmers" },
    { img: consultancy17Img, caption: "Agricultural Innovation" },
    { img: consultancy18Img, caption: "Community Training" },
    { img: consultancy19Img, caption: "Youth Empowerment" },
    { img: consultancy20Img, caption: "Agricultural Practices" },
    { img: consultancy21Img, caption: "Hands-On Training" },
    { img: consultancy22Img, caption: "Field Training" },
    { img: consultancy23Img, caption: "Agricultural Education" },
    { img: consultancy24Img, caption: "Community Development" },
    { img: consultancy25Img, caption: "Shabu Training 2021" }
  ];

  const tabContent: Record<string, JSX.Element> = {
    health: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Health, Productivity & Economic empowerment
                </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          The Shabu training embraced a rural impact approach, focusing on sustainable change through technology. Participants learned to cultivate orange-fleshed sweet potato (OFSP) using eco-friendly methods, enhancing food security and nutrition in their communities. The training emphasized practical skills, enabling farmers to adapt to local conditions and market demands.
         </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy4Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    development: (
      <div className="flex flex-col md:flex-row-reverse items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
           Sustainable Change of Orange-Fleshed Sweet Potato (OFSP) Farming
          </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Shabu training carried out extensive hands on workshops, technical sessions, and field demonstrations. Participants engaged in practical exercises, learning to cultivate OFSP using eco-friendly methods. The training emphasized sustainable agricultural practices, empowering farmers to improve productivity while preserving the environment.
          </p>
        </div>
        <div className="md:w-1/2">
          <img src={chysonImg} alt="Mentorship" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    knowledge: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
            NAQS Training: Empowering Youth Agripreneurs
          </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          In order to contribute to food and nutrition security, improve export opportunities for some Nigeria agricultural products especially Orange Fleshed Sweet Potato, and provide economic empowerment, Nigeria Agricultural Quarantine Service (NAQS) facilitated some community trainings on the production and processing of OFSP with Simdozi International Limited as the implementing company.
          </p>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
Shabu is a community in Lafia North Local Government Area of Nasarawa State. From 24th to 26th June, 2021, a group of thirty-five (35) youths were trained on Orange fleshed sweet potato and empowered with planting materials.
          </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy2Img} alt="Knowledge Sharing" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    )
  };

  return (
    <div className="about-container">
      {/* Hero Section */}
      <div
        className="relative h-[60vh] flex items-center justify-center text-white bg-cover bg-center z-0"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-black opacity-50 z-0" />
        <div className="z-10">
          <TextEffect text="Shabu Training 2021" className="hero-title" />
        </div>
      </div>

      {/* Tabbed Pane Section */}
      <div className="px-4 sm:px-[6%] mt-20 mb-24 gap-6">
                <div className="flex flex-wrap justify-center mb-8 space-x-4">               
          <button
            onClick={() => setActiveTab("knowledge")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "knowledge" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            NAQS Powered Community Sensitization and Trainings
          </button>

          <button
            onClick={() => setActiveTab("development")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "development" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
        Sustainable Change through Technology          </button>
         
            <button
            onClick={() => setActiveTab("health")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "health" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Health, Productivity & Economic empowerment
                 </button>
        </div>

        <div className="transition-all duration-500">{tabContent[activeTab]}</div>
      </div>


      {/* Overview Section */}
      <div className="relative">
        <div
          className="relative bg-green-500 text-white px-4 sm:px-[5%] py-20 bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${bgIMG})` }}
        >
          <div className="absolute inset-0 bg-green-650 opacity-80 z-0" />
          <div className="relative z-10 flex md:flex-row flex-col justify-between items-center gap-16">
            <div className="md:w-[40%] w-full flex justify-center">
              <img src={missionImage} alt="Empowering Farmers" className="w-[80%] max-w-[450px]" />
            </div>
            <div className="md:w-[60%] w-full space-y-4">
              <TextFade animation="fade-down">
                <h1 className="text-[30px] md:text-[40px] font-bold text-white mb-4 leading-tight">
                  <TextEffect text4="TRAINING & PRACTICAL DEMONSTRATION OF ORANGE-FLESHED SWEETPOTATO (OFSP)" />
                </h1>
              </TextFade>
                <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
                Our trainers listen to farmers, learning from their experiences and understanding their challenges.
              </p>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
                Using cultural understanding and local language, we provide practical, adaptable techniques.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Gallery Section */}
      <div className="px-4 sm:px-[5%] mt-24 mb-20">
        <TextFade animation="fade-up">
          <h1 className="text-center text-[24px] md:text-[30px] font-bold text-dark mb-8">
            <TextEffect part4="Shabu Training 2021 Gallery" />
          </h1>
        </TextFade>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          navigation
          autoplay={{ delay: 3000 }}
          loop
          modules={[Navigation, Autoplay]}
        >
          {trainingGallery.map(({ img, caption }, index) => (
            <SwiperSlide key={index}>
              <div
                className="relative w-full h-[260px] sm:h-[300px] rounded-xl overflow-hidden group cursor-pointer"
                onClick={() => setModal({ img, caption })}
              >
                <img src={img} alt={caption} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300">
                  <p className="text-white text-lg font-bold">{caption}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {modal && <ImageModal image={modal.img} caption={modal.caption} onClose={() => setModal(null)} />}
    </div>
  );
};

export default ShabuTraining;
